import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { uiStore } from 'shared/store/uiStore'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseEventInboxMemberRemoved } from 'entities/Inbox/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { eventEmitterStore } from 'entities/EventEmitter'
import { ConversationsPath } from 'pages/conversations/route/conversationsPath'

export const useEventInboxMemberRemoved = () => {
  const { inboxesStore, usersStore, websocket } = useEntitiesContext()
  const { pathname } = useLocation()

  const handle = (data: IResponseEventInboxMemberRemoved) => {
    const userId = usersStore.user?.id

    if (!userId) return

    inboxesStore.removeMemberFromInbox(data.id, userId)

    if (!inboxesStore.sharedInboxes.length) {
      if (pathname.includes(ConversationsPath.root)) {
        uiStore.changeRoute({
          path: `/${ConversationsPath.root}`,
        })
      }

      inboxesStore.fetchUser()
      eventEmitterStore.emit('reset_conversation_list')
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.InboxMemberRemoved, handle), [pathname])
}
